import React from "react";
import {InputAdornment} from "@mui/material";
import ContainerValidation from "../../Dashboard/Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../Dashboard/Visitor/External/Components/HeaderValidation";
import BodyValidation from "../../Dashboard/Visitor/External/Components/BodyValidation";
import BuildingRegistrationIdentifyYouApp from "./Functionality/BuildingRegistrationIdentifyYouApp";
import {CustomTextField} from "../../../components/CustomTextField";
import {isEmailFormat} from "../../../Apis/functions";
import {EmailSubsectionChip} from "../../../components/buttons/IconButtons";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const BuildingRegistrationIdentifyYou = () => {
    const {
        t,
        steps,
        activeStep,
        emptyFields,
        identityDetail,
        handleChange,
        handleClickNext,
        handleNavigateBack,
        textBtnNext
    } = BuildingRegistrationIdentifyYouApp();

    if (!steps) return <></>;

    return (
        <ContainerValidation>
            <HeaderValidation
                activeStep={activeStep}
                steps={steps?.TOTAL + 1}
                click={() => {
                    handleNavigateBack()
                }}
                showBtnBack={true}
                headerCenter={
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center align-self-center gap-1">
                        <div className="d-flex flex-column align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">
                                {t('lets_identify_you')}
                            </p>
                            <p className="fs-24-to-18 font-color-general-950 text-center">
                                {t('enter_the_information_associated_with_your_building_registration')}
                            </p>
                        </div>
                    </div>
                }
            />

            <BodyValidation
                click={() => {
                    handleClickNext();
                }}
                showBtnPrev={false}
                textBtnNext={textBtnNext}
            >
                <div className="row mt-5">
                    <div className={"col-sm-12 col-md-6 px-1"}>
                        <CustomTextField
                            id={'txt_briy_name'}
                            length={128}
                            name={'name'}
                            value={identityDetail?.name}
                            trans={'name'}
                            type={'text'}
                            disabled={false}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            placeholder={t("enter_your_name")}
                        />
                    </div>
                    <div className={"col-sm-12 col-md-6 px-1"}>
                        <CustomTextField
                            id={'txt_briy_last_name'}
                            length={128}
                            name={'lastName'}
                            value={identityDetail?.lastName}
                            trans={'last_name'}
                            type={'text'}
                            disabled={false}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            placeholder={t("enter_your_last_name")}
                        />
                    </div>
                    <div className={"col-12 px-1"}>
                        <CustomTextField
                            id={'txt_briy_email'}
                            length={128}
                            name={'email'}
                            value={identityDetail?.email}
                            trans={'email'}
                            type={'text'}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            disabled={false}
                            isValid={(!identityDetail?.email || isEmailFormat(identityDetail.email))}
                            isValidText={'email_format_invalid'}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <EmailSubsectionChip className={'w-h-24px'} />
                                    </InputAdornment>
                                ),
                            }}
                            placeholder={t("enter_your_email_address")}
                        />
                    </div>
                    <div className={"col-12 px-1"}>
                        <CustomTextField
                            id={'txt_briy_unit'}
                            length={128}
                            name={'unit'}
                            value={identityDetail?.unit}
                            trans={'unit'}
                            type={'text'}
                            disabled={false}
                            onChange={handleChange}
                            emptyFields={emptyFields}
                            required={true}
                            placeholder={t("enter_your_apartment_or_unit")}
                        />
                    </div>
                </div>
            </BodyValidation>
        </ContainerValidation>
    )
}

export default BuildingRegistrationIdentifyYou
